(function ($, Drupal) {

  'use strict';

  Drupal.behaviors.paragraph_brands = {
    attach: function (context, settings) {

      $(once('slick', '.paragraph--type--brands')).each(function () {
        var autoplay = $(this).hasClass('autoplay');

        $(this).find('.field--name-field-brands').slick({
          autoplay: autoplay,
          autoplaySpeed: 2000,
          infinite: true,
          speed: 300,
          slidesToShow: 6,
          slidesToScroll: 1,
          arrows: !autoplay,
          prevArrow: '<div class="slick-prev"></div>',
          nextArrow: '<div class="slick-next"></div>',
          lazyLoad: 'progressive',
          responsive: [
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 5,
              }
            },
            {
              breakpoint: 940,
              settings: {
                slidesToShow: 4,
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 3,
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 2,
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
              }
            }
          ]
        });
      });
    }
  };

})(jQuery, Drupal);
